module.exports = __webpack_public_path__ + "static/media/lak_logo.0f016712.svg";